<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M14.823 26.613C15.535 27.483 16 28 16 28s.466-.516 1.177-1.386C19.49 23.787 24.4 17.216 24.4 12.4 24.4 7.755 20.644 4 16 4a8.393 8.393 0 00-8.4 8.4c0 4.816 4.911 11.387 7.223 14.213zM16 25.208a53.84 53.84 0 002.708-3.653c1.016-1.506 2.006-3.165 2.737-4.796.74-1.655 1.155-3.149 1.155-4.36 0-3.65-2.95-6.6-6.6-6.6-3.65 0-6.6 2.95-6.6 6.6 0 1.211.414 2.705 1.156 4.36.73 1.63 1.72 3.29 2.736 4.796A53.874 53.874 0 0016 25.208zM19.3 12.1a3.3 3.3 0 11-6.6 0 3.3 3.3 0 016.6 0zm-1.8 0a1.5 1.5 0 11-2.999 0 1.5 1.5 0 013 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'localizationPinOutline'
}
</script>
